import { spWarnTags } from "@eventr/common";
import axios, { InternalAxiosRequestConfig } from "axios";
import { useConnectivityStore } from "../../feat/connectivity/connectivity.store";
import { isGuestSession } from "../../feat/guest/guest.store";
export const guestAbortRequestInterceptor = (request: InternalAxiosRequestConfig) => {
  if (request.NOT_IN_GUEST === true) {
    if (isGuestSession()) {
      throw new axios.Cancel("Request cancelled: Guest mode restriction.");
    }
  }
  if (!useConnectivityStore.getState().isConnectivityAvailable) {
    // Cancelled before the request leaves the app, so downstream this is a failure with
    // no HTTP status behind it.
    spWarnTags("Request cancelled, no connectivity", ["HTTP"], request.url);
    throw new axios.Cancel("Request cancelled: No connectivity.");
  }

  return {
    ...request,
  };
};
